"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const bs_1 = require("react-icons/bs");
const fa_1 = require("react-icons/fa");
const Button_1 = __importDefault(require("../../../elements/Button"));
function ActionsButton({ onFloatBtnClick }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "float-molecule-actions", style: { display: 'flex', zIndex: 0 }, children: [(0, jsx_runtime_1.jsx)(Button_1.default.Action, { style: { fontSize: '14px' }, fill: "clear", className: "handle", children: (0, jsx_runtime_1.jsx)(bs_1.BsArrowsMove, {}) }), (0, jsx_runtime_1.jsx)(Button_1.default.Danger, { style: { fontSize: '14px' }, fill: "clear", onClick: onFloatBtnClick, children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, {}) })] }));
}
exports.default = ActionsButton;
